const project_catalog = {
    project_catalog_items: [
        {
            id: "aws_account_setup",
            name: "AWS Account Setup",
            description: "Set up an AWS account for single sign-on and/or DTAP-environments.",
            tags: ["AWS", "setup", "SSO", "DTAP"]
        },
        {
            id: "fullstack_app_dev",
            name: "Fullstack Application Development",
            description: "Design, build, and maintain web or mobile applications (frontend, backend, APIs, databases).",
            tags: ["development", "fullstack"]
        },
        {
            id: "platform_engineering",
            name: "Platform Engineering & DevOps",
            description: "Design and implement CI/CD pipelines, automate cloud infrastructure, and enable efficient DevOps practices.",
            tags: ["DevOps", "platform"]
        },
        {
            id: "adr",
            name: "Architecture Decision Record",
            description: "I'll help you write a high-level architecture decision record (ADR), you'll do the implementation yourself.",
            tags: ["architecture", "DIY"]
        },
        {
            id: "design_document",
            name: "Design Document",
            description: "I'll help you write a low-level design document, you'll do the implementation yourself.",
            tags: ["architecture", "DIY"]
        },
        {
            id: "ai_projects",
            name: "AI & Machine Learning Projects",
            description: "Develop and deploy LLMs, agentic AI, chatbots, timeseries forecasting, and other ML solutions.",
            tags: ["AI", "ML"]
        },
        {
            id: "lifecycle_management",
            name: "Lifecycle Management",
            description: "Manage version upgrades for infrastructure, databases, and applications.",
            tags: ["lifecycle", "upgrade"]
        },
        {
            id: "migration_projects",
            name: "Migration Projects",
            description: "Plan and execute migration of systems, data, or infrastructure (cloud, on-prem, hybrid).",
            tags: ["migration"]
        },
        {
            id: "performance_optimization",
            name: "Performance Optimization",
            description: "Analyze and optimize performance of applications, infrastructure, or databases.",
            tags: ["performance"]
        },
        {
            id: "fix_vibe_coded_applications",
            name: "Fix Vibe-Coded Applications",
            description: "Turn your vibe-coded prototype into a secure, stable, production-ready application.",
            tags: ["development", "fullstack", "AI"]
        },
        {
            id: "cost_reduction",
            name: "Cost Reduction",
            description: "Identify and implement cost-saving measures for IT systems and cloud infrastructure.",
            tags: ["cost"]
        },
        {
            id: "cybersecurity",
            name: "Cybersecurity Assessment & Hardening",
            description: "Assess, improve, and monitor the security of applications and infrastructure.",
            tags: ["security"]
        },
        {
            id: "workshops",
            name: "Workshops & Training",
            description: "Deliver workshops or training sessions on Python, AWS, application security, or DevOps best practices.",
            tags: ["workshop", "training"]
        },
        {
            id: "documentation",
            name: "Documentation & Knowledge Transfer",
            description: "Create documentation and facilitate knowledge transfer for projects and teams.",
            tags: ["documentation"]
        },
        {
            id: "architecture_overview",
            name: "Architecture Overview and Recommendations",
            description: "Create an overview of your current IT architecture with recommendations.",
            tags: ["architecture"]
        },
        {
            id: "unit_testing",
            name: "Unit Testing",
            description: "Create automated unit tests for existing workloads, optionally including code coverage.",
            tags: ["testing", "unit testing", "code coverage"]
        },
        {
            id: "end_to_end_testing",
            name: "End-to-End Testing",
            description: "Create automated end-to-end testing for existing workloads.",
            tags: ["testing", "end-to-end", "E2E"]
        },
        {
            id: "monitoring",
            name: "Monitoring",
            description: "Build application monitoring, such as a dashboard and alerting.",
            tags: ["monitoring"]
        },
        {
            id: "data_backup",
            name: "Data Backup",
            description: "Set up a automated backups, for example in AWS.",
            tags: ["backup"]
        },
        {
            id: "disaster_recovery",
            name: "Disaster Recovery",
            description: "Execute a disaster recovery exercise.",
            tags: ["recovery"]
        },
        {
            id: "scaling",
            name: "Scaling",
            description: "Make sure your IT can handle increased load.",
            tags: ["scalability"]
        },
        {
            id: "hiring",
            name: "Hiring",
            description: "Help with hiring personnel.",
            tags: ["hiring"]
        },
        {
            id: "mentoring",
            name: "Mentoring",
            description: "Mentor one or more team members.",
            tags: ["mentoring"]
        },
        {
            id: "secrets_management",
            name: "Secrets Management",
            description: "Implement a suitable secrets management tool to control credentials for machine identities.",
            tags: ["security", "secrets"]
        },
        {
            id: "code_scanning",
            name: "Static Code Vulnerability Scanning",
            description: "Implement a static code vulnerability scanning tool like SonarQube.",
            tags: ["security", "vulnerability scanning", "code", "sonarqube"]
        },
        {
            id: "artifact_repository",
            name: "Artifact Repository",
            description: "Implement a custom artifact repository manager like Nexus.",
            tags: ["security", "artifact repository", "nexus"]
        },
        {
            id: "dependency_vulnerability_scanning",
            name: "Dependency Vulnerability Scanning",
            description: "Implement an open-source dependency vulnerability scanner like Dependabot.",
            tags: ["security", "dependency scanning", "nexusiq", "dependabot"]
        },
        {
            id: "encrypt_data_at_rest",
            name: "Encrypt Data-at-Rest",
            description: "Make sure stored data is encrypted, including key management.",
            tags: ["security", "encryption", "data-at-rest", "key management"]
        },
        {
            id: "encrypt_data_in_transit",
            name: "Encrypt Data-in-Transit",
            description: "Make sure data communication encrypted, including certificate management.",
            tags: ["security", "encryption", "data-in-transit", "certificate management"]
        },
        {
            id: "infrastructure_scanning",
            name: "Infrastructure Vulnerability Scanning",
            description: "Implement an infrastructure vulnerability scanning tool like Aquasec.",
            tags: ["security", "infrastructure scanning", "aquasec"]
        },
        {
            id: "firewall",
            name: "Firewall",
            description: "Make sure your firewalls are configured correctly.",
            tags: ["security", "firewall"]
        },
        {
            id: "web_application_firewall",
            name: "Web Application Firewall",
            description: "Implement a web application firewall.",
            tags: ["security", "web application firewall", "WAF"]
        }
    ]
}

export default project_catalog